import { useState, useCallback } from 'react'
import { useStreamGeneration } from '@/hooks/useStreamGeneration'
import InputArea from '@/components/InputArea'
import ResultArea from '@/components/ResultArea'
import iconDoc from '@/assets/images/icons/icon-doc.svg'

/** 引用条输入截断长度 */
const QUOTE_TRUNCATE_LENGTH = 50

/** 首页 — 组合 InputArea + ResultArea，作为多 Agent 流水线的入口 */
export default function Home() {
  const { agents, activeViewStep, onUserStepClick, isGenerating, startGeneration, retry } = useStreamGeneration()
  const [quotedInput, setQuotedInput] = useState('')
  const [fullInput, setFullInput] = useState('')

  const handleGenerate = useCallback(
    (input: string) => {
      const quoted = input.length > QUOTE_TRUNCATE_LENGTH ? `${input.substring(0, QUOTE_TRUNCATE_LENGTH)}...` : input
      setQuotedInput(quoted)
      setFullInput(input)
      startGeneration(input)
    },
    [startGeneration]
  )

  return (
    <div className="app">
      <div className="header">
        <h1>
          <img src={iconDoc} className="header-icon" alt="" />
          <span>PRD 辅助生成器</span>
        </h1>
        <span className="subtitle">输入一句话需求，AI 多 Agent 协作生成结构化 PRD</span>
      </div>

      <ResultArea
        agents={agents}
        activeViewStep={activeViewStep}
        onUserStepClick={onUserStepClick}
        isGenerating={isGenerating}
        quotedInput={quotedInput}
        fullInput={fullInput}
        onRetry={retry}
      />

      <InputArea onGenerate={handleGenerate} disabled={isGenerating} />
    </div>
  )
}
